/* eslint-disable react/prop-types */
import { memo } from 'react';
import { LAST } from 'conversations-message-history/constants/messagePositionDescriptors';
import { isCommonMessageFormat
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/cmfComparators';
// @ts-expect-error module not typed
import { isThreadComment } from 'conversations-message-history/comment-message/operators/cmComparators';
import { getSenderId, getSenderType, getTimestamp
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getMessage } from 'conversations-message-history/unpublished-messages/operators/getters';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { AGENT } from 'conversations-message-history/constants/messageUses';
import { COMMENT } from 'conversations-message-history/constants/tileMessageUses';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { getData } from 'conversations-message-history/senders/operators/getters';
// @ts-expect-error module not typed
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
// @ts-expect-error module not typed
import { senderEmailDoesNotMatchVisitor } from 'conversations-message-history/senders/operators/senderEmailDoesNotMatchVisitor';
import Sender from 'conversations-message-history/senders/records/Sender';
import TileMessage from '../tile-message/TileMessage';
// import CommonMessageContent from '../common-message/CommonMessageContent';
import CommonAttachmentsFooter from '../common-message/CommonMessageAttachmentsFooter';
import CommonMessageSection from '../common-message/CommonMessageSection';
import SlottedMessage from '../slotted-message/SlottedMessage';

// @ts-expect-error module not typed

// @ts-expect-error module not typed
import CommentMessageBody from '../comment/CommentMessageBody';
import FullSenderName from '../senders/components/FullSenderName';
import { getFromSenderName, getOriginalFromSenderEmail } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import SenderAvatar from '../avatar/SenderAvatar';
import { jsx as _jsx } from "react/jsx-runtime";
const UNPUBLISHED_MESSAGE = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
  message: "conversations-inbox-message-history.status.publishing.UNPUBLISHED"
});
const Annotation = () => /*#__PURE__*/_jsx(Small, {
  use: "help",
  children: UNPUBLISHED_MESSAGE
});
Annotation.displayName = 'Annotation';
const renderHeaderPublishingData = () => /*#__PURE__*/_jsx("b", {
  children: UNPUBLISHED_MESSAGE
});
const ActivelyPublishingMessage = /*#__PURE__*/memo(({
  fileAttachments,
  message: activelyPublishingMessage,
  onClickAvatar,
  positionDescriptors,
  plainTextMode,
  senders,
  ungatedForThreadMessagesUIImprovements
}) => {
  const message = getMessage(activelyPublishingMessage);
  const shouldRenderFooter = positionDescriptors.includes(LAST);
  if (isThreadComment(message)) {
    return /*#__PURE__*/_jsx(TileMessage, {
      use: COMMENT,
      positionDescriptors: positionDescriptors,
      children: /*#__PURE__*/_jsx(CommentMessageBody, {
        message: message,
        onClickAvatar: onClickAvatar,
        senders: senders,
        renderHeaderMetadata: renderHeaderPublishingData
      })
    });
  }
  if (isCommonMessageFormat(message)) {
    const messageTimestamp = getTimestamp(message) || Date.now();
    const senderId = getSenderId(message);
    const senderType = getSenderType(message);
    const asyncSender = findSender(senderId, senderType, senders);
    const isLoading = isSenderLoading(asyncSender);
    let sender = getData(asyncSender);
    if (!sender || senderEmailDoesNotMatchVisitor({
      sender,
      message
    })) {
      sender = Sender({
        senderType,
        firstName: getFromSenderName(message) || null,
        email: getOriginalFromSenderEmail(message) || null
      });
    }
    return /*#__PURE__*/_jsx(SlottedMessage, {
      container: {
        componentProps: {
          positionDescriptors,
          use: AGENT,
          'data-test-id': 'actively-publishing-message',
          ungatedForThreadMessagesUIImprovements
        }
      },
      avatar: {
        Component: SenderAvatar,
        isLoading,
        componentProps: {
          onClick: onClickAvatar,
          sender,
          present: true,
          size: 'sm'
        }
      },
      title: {
        Component: FullSenderName,
        componentProps: {
          isLoading,
          sender,
          'data-test-id': 'sender-name'
        }
      },
      timestamp: {
        componentProps: {
          timestamp: messageTimestamp
        }
      },
      body: {
        Component: CommonMessageSection,
        componentProps: {
          message,
          fileAttachments,
          positionDescriptors,
          plainTextMode
        }
      },
      footerBody: {
        Component: CommonAttachmentsFooter,
        componentProps: {
          message,
          fileAttachments
        }
      },
      annotation: shouldRenderFooter ? {
        Component: Annotation
      } : null
    });
  }
  return null;
});
ActivelyPublishingMessage.displayName = 'ActivelyPublishingMessage';
export default ActivelyPublishingMessage;